function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.34 11.882l18.338 17.6c.372.359.868.518 1.363.518.496 0 .991-.2 1.363-.518l18.255-17.6a1.055 1.055 0 000-1.553 1.15 1.15 0 00-.785-.319c-.289 0-.578.12-.784.319L20.04 27.69 1.951 10.328a1.151 1.151 0 00-1.61 0 1.055 1.055 0 000 1.554z",
  fill: "#444"
});

function SvgScrollinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgScrollinline;